import type * as React from 'react';
import { Card } from '../card/card.tsx';
import { cn } from '../../lib/cn.ts';

export type ChatSurfaceProps = Omit<React.ComponentProps<'section'>, 'style'>;

/**
 * A conversation that stands on a page rather than in the drawer: the same
 * white surface, holding the conversation (`ChatDrawerBody`) above its
 * composer (`ChatSurfaceFooter`). The page decides its height — given one, the
 * conversation scrolls inside it; left unbounded, it grows with the page.
 */
export function ChatSurface({ className, ...props }: ChatSurfaceProps) {
  return (
    <Card
      as='section'
      padding='none'
      data-slot='chat-surface'
      className={cn('flex flex-col', className)}
      {...props}
    />
  );
}

export type ChatSurfaceFooterProps = Omit<React.ComponentProps<'div'>, 'style'>;

/** Where the composer sits on a chat surface, set off from the conversation above it. */
export function ChatSurfaceFooter({ className, ...props }: ChatSurfaceFooterProps) {
  return (
    <div
      data-slot='chat-surface-footer'
      className={cn('border-t border-line p-3.5', className)}
      {...props}
    />
  );
}
